import React from "react";
import { Divider, Grid, Stack } from "@mui/material";

import type { SelectedTree } from "./rightPanel/types";

import EmptySelection from "./rightPanel/EmptySelection";
import RightPanelHeader from "./rightPanel/RightPanelHeader";
import SelectedAECard from "./rightPanel/SelectedAECard";

interface Props {
  selected: SelectedTree;
  canConfirm: boolean;
  selectedAECount: number;
  onClearAll: () => void;
  onRemoveOG: (aeId: string, ceId: string, ogId: string) => void;
}

const ObjectiveSelectRightPanel: React.FC<Props> = ({
  selected,
  canConfirm,
  selectedAECount,
  onClearAll,
  onRemoveOG,
}) => {
 const aeNodes = Object.values(selected ?? {});

  console.log("selected", selected);
  return (
    <Grid
      item
      xs={12}
      md={5}
      sx={{
        minHeight: 360,
        maxHeight: 360,
        overflow: "auto",
      }}
    >
      <RightPanelHeader
        selectedAECount={selectedAECount}
        canConfirm={canConfirm}
        onClearAll={onClearAll}
      />

      <Divider />

      {!canConfirm ? (
        <EmptySelection />
      ) : (
        <Stack spacing={1.2} p={1.5}>
          {aeNodes.map((ae) => (
            <SelectedAECard
              key={ae.id}
              aeId={ae.id}
              aeTexto={ae.texto}
              criterios={ae.criterios}
              onRemoveOG={(ceId, ogId) => onRemoveOG(ae.id, ceId, ogId)}
            />
          ))}
        </Stack>
      )}
    </Grid>
  );
};

export default ObjectiveSelectRightPanel;
